import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import QRCode from "react-qr-code";
import { Button, IconCheckmark } from '../../../components';
import css from './SignatureBox.css';

const SignatureBox = ({ handleSignProtocol, protocolType, protocolKey, txId, signProtocolInProgress, signProtocolSuccess, signProtocolError }) => {
  const sigCanvas = useRef(null);
  const [qrCodeOpen, setQrCodeOpen] = useState(false);
  const [isEmpty, setIsEmpty] = useState(true);

  function clear() {
    sigCanvas.current.clear();
    setIsEmpty(true);
  }

  function save() {
    sigCanvas.current.getTrimmedCanvas().toBlob((blob) => {
      handleSignProtocol(blob, protocolType)
    });
  }

  return (
    <div className={css.sigContainer}>
      {!qrCodeOpen ? (
        <div className={css.signatureField}>
          {signProtocolSuccess && (
            <div className={css.signatureSuccess}>
              <div><IconCheckmark className={css.success} size="big" /></div>
              <div>Protokół został podpisany</div>
              {signProtocolSuccess}
            </div>
          )}
          {
            signProtocolError && (
              <div className={css.signatureError}>
                <div>Protokół nie został podpisany</div>
                <div>{signProtocolError?.title}</div>
              </div>
            )
          }
          <SignatureCanvas
            penColor="#3643BA"
            canvasProps={{ className: css.sigCanvas }}
            ref={sigCanvas}
            onEnd={() => setIsEmpty(false)}
          />
        </div>
      ) : (
        <QRCode
          size={100}
          style={{ height: "auto", maxWidth: "100%", width: "200px", marginBottom: 10, marginLeft: 'auto', marginRight: 'auto' }}
          value={`${process.env.REACT_APP_CANONICAL_ROOT_URL}/sign?page=${protocolType}&protocolKey=${protocolKey}&tx=${txId}`}
          viewBox={`0 0 256 256`}
        />
      )}
      {!qrCodeOpen ? (
        <div className={css.buttonsContainer}>
          <Button className={css.buttons} type="button" onClick={() => setQrCodeOpen(true)}>QR Code</Button>
          <Button className={css.buttons} type="button" onClick={clear}>Wyczyść</Button>
          <Button
            className={css.buttons}
            type="button"
            onClick={save}
            inProgress={signProtocolInProgress}
            disabled={isEmpty || signProtocolInProgress || signProtocolSuccess}
          >
            Podpisz
          </Button>
        </div>
      ) : (
        <div className={css.buttonsContainer}>
          <Button
            className={css.buttons}
            type="button"
            onClick={() => setQrCodeOpen(false)}
          >
            Podpis
          </Button>
        </div>
      )}
    </div>
  );
};

export default SignatureBox;
